import React, { useState } from "react";
import { Home, InfoIcon, CogIcon, SplitSquareVertical } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export const SideBar = ({ setCurrentScreen, showSidebar, setShowSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [menuItems] = useState([
    { name: "Dashboard", icon: <Home size={20} />, path: "/" },
    {
      name: "Configuration",
      icon: <CogIcon size={20} />,
      path: "/configuration",
    },
    {
      name: "Power Splitter",
      icon: <SplitSquareVertical size={20} />,
      path: "/power-splitter-meters",
    },
  ]);

  const handleNavigate = (e, path, name, newTab = false) => {
    e.currentTarget.blur();
    setCurrentScreen(name);
    if (newTab) return;
    navigate(path);
    if (showSidebar) {
      setShowSidebar(false);
    }
  };

  return (
    <aside
      className={`
        fixed z-50 top-0 left-0 h-screen w-[64] bg-sidebar-gradient text-primary-dark
        flex flex-col rounded-r-2xl p-3 transition-transform duration-300
        ${showSidebar ? "translate-x-0" : "-translate-x-full"}
        lg:translate-x-0 lg:static md:rounded-2xl
        overflow-y-auto overscroll-contain
        scrollbar-thin scrollbar-thumb-subText scrollbar-track-white scrollbar-
      `}
    >
      <div className="p-4 text-center uppercase font-normal text-sm tracking-4">
        NanoWattz
      </div>
      <div className="h-0.5 w-auto bg-sidebar-line-gradient mb-4"></div>

      <nav className="flex-1">
        {menuItems.map((item, key) => (
          <a
            key={key}
            href={item.newTab ? item.path : undefined}
            target={item.newTab ? "_blank" : "_self"}
            rel={item.newTab ? "noopener noreferrer" : undefined}
            className={`justify-between outline-none rounded-2xl text-primary-dark mb-1 flex items-center gap-3 px-3 py-2 text-sm hover:cursor-pointer transition ${
              location.pathname === item.path ||
              (item.path === "/" && location.pathname.startsWith("/dashboard"))
                ? "bg-primary-dark text-primary-light"
                : "hover:bg-primary-light"
            }`}
            onClick={(e) =>
              handleNavigate(e, item.path, item.name, item.newTab)
            }
            style={{ textDecoration: "none" }}
          >
            <div className="flex gap-3 items-center">
              <div
                className={`bg-primary-dark text-primary-normal rounded-xl p-2 ${
                  location.pathname === item.path ||
                  (item.path === "/" &&
                    location.pathname.startsWith("/dashboard"))
                    ? "bg-primary-normal text-primaryDark"
                    : "hover:bg-primary-dark hover:text-primary-normal"
                }`}
              >
                {item.icon}
              </div>
              {item.name}
            </div>
            {item?.rightIcon}
          </a>
        ))}
      </nav>

      <div className="mb-3 min-h-48 relative p-3 rounded-2xl bg-primary-dark font-nexa flex-col overflow-hidden mt-40">
        <div className="absolute inset-0 bg-help-section bg-cover bg-left opacity-70"></div>

        <div className="relative z-10">
          <InfoIcon size={40} className="bg-primary-light p-1 rounded-lg" />
          <p className="font-nexa text-lg text-primary-light leading-10 mb-0">
            Need help
          </p>
          <p className="font-nexa text-sm text-primary-light leading-3 mt-0">
            Email us
          </p>
          <button
            className="w-full py-2 bg-primary-dark text-primary-light rounded-full opacity-80"
            onClick={() =>
              (window.location.href = "mailto:support@nanowattz.com")
            }
          >
            Email us
          </button>
        </div>
      </div>
    </aside>
  );
};
